export default import.meta.ROLLDOWN_FILE_URL_moxMPzt2SkBPQ20CK_dFDg